import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import FormInput from "components/atoms/input/FormInput";
import SelectBox from "components/atoms/input/SelectBox";
import useLoading from "components/atoms/loading/useLoading";
import Text from "components/atoms/text/Text";
import useToast from "components/atoms/toast/useToast";

import AbstractModal from "components/page/modal/AbstractModal";

import { useManuscriptCreate, useManuscriptTemplates } from "hooks/queries/usePapers";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

const LabelRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 4px 0;
`;

const LabelText = styled(Text).attrs({
    variant: "body-md-500",
    color: "var(--color-SubBlack)",
})``;

function ManuscriptAddModal(props) {
    const { setLoading } = useLoading();
    const { setToast } = useToast();

    const [displayName, setDisplayName] = useState("");
    const inputRef = useRef(null);
    const [templateId, setTemplateId] = useState(0);
    const { data: manuscriptTemplates } = useManuscriptTemplates();
    const manuscriptCreateMutation = useManuscriptCreate();

    const templates = [
        { id: 0, name: "빈 문서" },
        ...((Array.isArray(manuscriptTemplates) ? manuscriptTemplates : manuscriptTemplates?.results || []).map(
            (template) => ({
                id: template.id,
                name: template.display_name,
            }),
        ) || []),
    ];

    const addManuscript = async () => {
        if (displayName.trim().length < 1) {
            Alert("warn", "에러", "제목을 입력해주세요.");
            return;
        }

        try {
            setLoading(true);
            const data = await manuscriptCreateMutation.mutateAsync({
                display_name: displayName.trim(),
                template_id: templateId,
            });
            setToast("논문원고가 생성되었습니다.", "info");
            props.onSuccess?.(data);
            props.exitModal();
        } catch (error) {
            Alert("warn", "에러", error.response?.data?.error || "서버에 오류가 발생하였습니다.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <AbstractModal
            modalTitle="논문원고 추가"
            width={480}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "확인",
                leftOnClick: props.exitModal,
                rightOnClick: addManuscript,
            }}
        >
            <Container>
                <FormInput
                    labelDp="none"
                    placeholder="제목을 입력하세요."
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, addManuscript);
                    }}
                    ref={inputRef}
                />
                <LabelRow>
                    <LabelText>템플릿</LabelText>
                </LabelRow>
                <SelectBox
                    width={"100%"}
                    height={"28px"}
                    optionWidth={"100%"}
                    optionAlign={"left"}
                    optionMaxHeight={"auto"}
                    items={templates}
                    textAlign={"left"}
                    value={templateId}
                    onChange={(value) => {
                        setTemplateId(value);
                    }}
                />
            </Container>
        </AbstractModal>
    );
}

export default ManuscriptAddModal;
